export const myip = window.location.hostname;
export const protocol = window.location.protocol;

const live_site_key = "6Ldw1c0ZAAAAALvaz6Eiwk118oIFFwuv7yabXrR1";

var finalURL = "";
if (protocol == "http:") {
  finalURL = protocol + "//" + myip + "/dev/api";
}
if (protocol == "https:") {
  finalURL = protocol + "//" + myip + "/dev/api";
}
const extra_op_url = "";
const USBStickImage =
  protocol + "//" + myip + "/dev/images/USB_250x250px.jpg";
const imageUrl = finalURL + "/retrieveImage/";
const posterTemplateURL = finalURL + "/retrievePosterTemplateImage/";
const posterURL = finalURL + "/retrievePosterImage/";

export const environment = {
  production: true,
  URL: finalURL,
  imageURL: imageUrl,
  posterTemplateURL: posterTemplateURL,
  posterURL: posterURL,
  USBImage: USBStickImage,
  fb_app_id: "",
  recaptach2_siteKey: live_site_key,
  extra_url: extra_op_url,
  worldpayClientKey: "T_C_295a0a0f-17f2-4ecb-a603-c2c6729993c5",
  excludeLoaderURL: [
    `${finalURL + "/ftpZone/imageUpload"}`,
    `${finalURL + "/ftpZone/edit"}`,
    `${finalURL + "/ftpZone/sendMail"}`,
  ],
  isMaintainanceMode: false
};
